import { Component, OnInit, Renderer2, SecurityContext } from '@angular/core'
import { Observable, of } from 'rxjs'
import {
  CmsNavigationComponent,
  CmsService,
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
  CurrencyService,
  AuthStorageService,
} from '@spartacus/core'
import {
  CmsComponentData,
  LaunchDialogService,
  NavigationService,
} from '@spartacus/storefront'
import { switchMap, take } from 'rxjs/operators'
import { Router } from '@angular/router'
import { ChangeCustAccountService } from '../change-cust-account/change-cust-account.service'
import { ChangeDetectorRef } from '@angular/core'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { DomSanitizer } from '@angular/platform-browser'
import { CommonService } from '../../../shared/services/common.service'

@Component({
  standalone: false,
  // tslint:disable-next-line:component-selector
  selector: 'vs-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public showSideNav: boolean = false
  registerUrl: string = ''
  displayChangeAccount: boolean = false
  userTypeVal: any

  constructor(
    private componentData: CmsComponentData<CmsNavigationComponent>,
    private cmsService: CmsService,
    private auth: AuthService,
    private service: NavigationService,
    private router: Router,
    private commonService: CommonService,
    protected globalMessageService: GlobalMessageService,
    protected launchDialogService: LaunchDialogService,
    public r: Renderer2,
    private currencyService: CurrencyService,
    private changeCustAccountService: ChangeCustAccountService,
    private changeDetection: ChangeDetectorRef,
    private authStorageService: AuthStorageService,
    private userAccountFacade: UserAccountFacade,
    private domSanitizer: DomSanitizer
  ) {}
  userClicked = false
  data$: Observable<CmsNavigationComponent> = this.componentData.data$
  user$: Observable<any>
  nodeData: any
  menuToggle = false
  width: boolean = false
  navComp$ = this.cmsService.getComponentData('MyAccountComponent')
  navCompCat$ = this.cmsService.getComponentData('VsRequestQuoteNavComponent')

  node$ = this.service.getNavigationNode(this.navComp$)

  nodes$ = this.service.getNavigationNode(this.navCompCat$)

  ngOnInit(): void {
    this.commonService.closeMenu.next({
      profileMenu: false,
      miniCart: false,
      megaNavMenu: false,
      changeAccMenu: false,
    })
    this.user$ = this.auth.isUserLoggedIn().pipe(
      // take(1),
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          // this.checkLegalEntitiesAndCustomerAccounts();
          this.userTypeVal = 'current'
          return this.userAccountFacade.get()
        } else {
          this.userTypeVal = 'anonymous'
          return of(undefined)
        }
      })
    )
    // this.user$.subscribe((res) => {
    //   if (res?.currency?.isocode) {
    //     // this.checkLegalEntitiesAndCustomerAccounts();
    //     this.currencyService.setActive(res.currency.isocode);
    //   }
    //   else {
    //     this.currencyService.setActive('USD');
    //   }
    // }, (error) => {
    //  /*  this.globalMessageService.add(
    //     error,
    //     GlobalMessageType.MSG_TYPE_ERROR,
    //     5000
    //   );
    //   window.scrollTo(0, 0); */
    // });

    this.cmsService.getComponentData('MyAccountComponent').subscribe(
      (resultArray) => {
        this.nodeData = resultArray
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.cmsService.getCurrentPage().subscribe(
      (resultArray) => {
        if (resultArray?.label === 'rfqCart') {
          this.auth.isUserLoggedIn().pipe(
            switchMap((isUserLoggedIn) => {
              if (isUserLoggedIn) {
                sessionStorage.setItem('userType-current', 'current')
              } else {
                sessionStorage.setItem('userType-current', 'anonymous')
                return of(undefined)
              }
            })
          )
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.cmsService
      .getComponentData('RegistrationLink')
      .subscribe((res: any) => {
        this.registerUrl = res.url
      })

    this.closeMenuOnOtherMenuEvent()
  }
  toggleMenu() {
    this.menuToggle = !this.menuToggle
    this.commonService.setMenuActive(false)
    this.commonService.passMessage('closeMegaMenu')
  }

  closeMenuOnOtherMenuEvent() {
    this.commonService.closeMenu.subscribe((menuStatus) => {
      this.menuToggle = menuStatus.profileMenu
      this.changeDetection.detectChanges()
    })
  }
  closeMenu(event) {
    const target = event.target
    const idAttr = target.attributes.id
    if (idAttr != null && idAttr !== undefined) {
      const value = idAttr.nodeValue
      if (value === 'userMenu') {
        return
      } else {
        this.menuToggle = false
      }
    }
    this.menuToggle = false
  }
  openMenu(event) {
    this.commonService.passMessage('closeMegaMenu')

    if (this.userClicked) {
      this.menuToggle = false
      this.userClicked = false
      return
    }
    this.menuToggle = true
    this.userClicked = true

    this.changeDetection.detectChanges()
    this.commonService.closeMenu.next({
      profileMenu: true,
      miniCart: false,
      megaNavMenu: false,
      changeAccMenu: false,
    })
  }
  getItem(item, event) {
    if (item.uid === 'SignOutNavNode' || item.title === 'Sign Out') {
      return
    } else {
      this.router.navigate([item.url])
      this.closeMenu(event)
    }
  }
  clearLocalStorageExcept(keepKeys){
    const savedStorage = keepKeys.map(key=>({
      key,
      value: localStorage.getItem(key)
    }));

    localStorage.clear();

    savedStorage.forEach(({key,value}) => {
      if(value !== null) localStorage.setItem(key, value);
    });
  }
  logout() {
    this.authStorageService.getToken().subscribe(
      (data) => {
        if (data && data.access_token) {
          if (data.access_token) {
            const urlParams = ['vslogin', 'revoke', data.access_token]
            const loginUrl = this.commonService.constructUrl(urlParams)
            this.commonService.getData_Text(loginUrl).subscribe(
              (res: any) => {
                if (res) {
                  this.clearLocalStorageExcept(['recent_searches']);
                  let returnUrl = res?.split('?')[1]?.split('=')[1]
                  returnUrl = returnUrl
                    ? returnUrl
                    : this.domSanitizer.sanitize(
                        SecurityContext.URL,
                        window.location.origin
                      )
                  window.location.href = this.domSanitizer.sanitize(
                    SecurityContext.URL,
                    returnUrl
                  )
                } else {
                  this.globalMessageService.add(
                    { key: 'userData.wentWrongLogout' },
                    GlobalMessageType.MSG_TYPE_ERROR,
                    10000
                  )
                }
              },
              (err) => {
                this.globalMessageService.add(
                  { key: 'userData.wentWrongLogout' },
                  GlobalMessageType.MSG_TYPE_ERROR,
                  10000
                )
              }
            )
          }
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  navigateProfile() {
    this.router.navigate(['my-profile'])
  }

  checkLegalEntitiesAndCustomerAccounts() {
    // Make an API call to check if the user have multiple Customer Accounts
    this.changeCustAccountService.getCustomerAccDetails().subscribe(
      (response) => {
        if (response !== null && response !== undefined) {
          if (response['b2bUnits'] !== undefined) {
            if (response['b2bUnits'].length > 1) {
              // display Change Account dropdown only if there are more than 1, b2bunits
              this.displayChangeAccount = true
              this.changeDetection.detectChanges()
            } else {
              // Make an API call to fetch the legal entities
              this.changeCustAccountService
                .getLegalEntities(response['b2bUnits'][0].uid)
                .subscribe(
                  (data) => {
                    if (data !== null && data !== undefined) {
                      if (
                        data['vsSalesArea'] !== undefined &&
                        data['vsSalesArea'].length > 1
                      ) {
                        // display Change Account dropdown only if there are more than 1, legal entities
                        this.displayChangeAccount = true
                      } else {
                        this.displayChangeAccount = false
                      }
                    } else {
                      this.displayChangeAccount = false
                    }
                    this.changeDetection.detectChanges()
                  },
                  (error) => {
                    /* this.globalMessageService.add(
                    error,
                    GlobalMessageType.MSG_TYPE_ERROR,
                    5000
                  );
                  window.scrollTo(0, 0); */
                  }
                )
            }
          } else {
            this.displayChangeAccount = false
          }
        } else {
          this.displayChangeAccount = false
        }
        this.changeDetection.detectChanges()
      },
      (error) => {
        /* this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        );
        window.scrollTo(0, 0); */
      }
    )
  }

  onRegisterClick() {
    window.location.href = this.domSanitizer.sanitize(
      SecurityContext.URL,
      this.registerUrl
    )
  }
}
